import api from '~/services/api';
import { agendamentoDataProps } from '../types';

const createAgendamento = async (
  agendamentoData: agendamentoDataProps,
): Promise<{ message: string; success: boolean }> => {
  const { data } = await api.post('/agendamento-de-contas', agendamentoData);
  return data;
};

const updateAgendamento = async (
  cod_seq_agendamento: number,
  agendamentoData: agendamentoDataProps,
): Promise<{ message: string; success: boolean }> => {
  const { data } = await api.put(
    `/agendamento-de-contas/${cod_seq_agendamento}`,
    agendamentoData,
  );
  return data;
};

const deleteAgendamento = async (
  cod_seq_agendamento: number,
): Promise<{ message: string; success: boolean }> => {
  const { data } = await api.delete(
    `/agendamento-de-contas/${cod_seq_agendamento}`,
  );
  return data;
};

export const agendamentoServices = {
  createAgendamento,
  updateAgendamento,
  deleteAgendamento,
};
